import { Link } from "react-router-dom";
import { Calendar, ArrowRight, Tag } from "lucide-react";
import { Badge } from "./ui/badge";

export default function BlogCard({ blog }) {
  const {
    title,
    slug,
    featured_image,
    excerpt,
    category,
    created_at,
    tags,
  } = blog;

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  return (
    <Link 
      to={`/blog/${slug}`}
      className="group block"
      data-testid={`blog-card-${slug}`}
    >
      <div className="rounded-2xl bg-card border border-white/5 overflow-hidden card-hover">
        {/* Image */}
        <div className="relative h-48 overflow-hidden">
          <img 
            src={featured_image} 
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            onError={(e) => {
              e.target.src = "https://images.unsplash.com/photo-1596838132731-3301c3fd4317?w=800";
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-card to-transparent" />
          <Badge className="absolute top-3 left-3 bg-primary/80 text-white">
            {category}
          </Badge>
        </div>

        {/* Content */}
        <div className="p-5">
          <h3 className="text-white font-bold text-lg mb-2 line-clamp-2 group-hover:text-primary transition-colors">
            {title}
          </h3>
          <p className="text-white/60 text-sm line-clamp-2 mb-4">{excerpt}</p>

          {/* Meta */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-white/40 text-xs">
              <Calendar className="w-3 h-3" />
              <span>{formatDate(created_at)}</span>
            </div>
            <span className="flex items-center gap-1 text-primary text-sm font-medium group-hover:gap-2 transition-all">
              Read More <ArrowRight className="w-4 h-4" />
            </span>
          </div>

          {/* Tags */}
          {tags && tags.length > 0 && (
            <div className="flex items-center gap-2 mt-3 pt-3 border-t border-white/5">
              <Tag className="w-3 h-3 text-white/40" />
              <div className="flex gap-1 flex-wrap">
                {tags.slice(0, 3).map((tag, i) => (
                  <span key={i} className="text-xs text-white/40 px-2 py-0.5 bg-white/5 rounded">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
